export const zh_CN = {
    "PREFIX": {
        "QUESTION": "问题",
        "QUESTION-PART": "问题",
        "PRE-RELEASE": "Pre-Release",
        "JOURNAL": "Journal"
    },
    "CONTENT": {
        "MARK": "{{totalMarks > 1 && '分' || '分'}}"
    }
};